import { setDetailsHeights } from "../utils/details"
import { qsa } from "../utils/dom"

export const initArguments = () => {
  setDetailsHeights(".argument__details")

  qsa(".argument__details").forEach((details) => {
    details.addEventListener("click", (e) => {
      if (e.target.closest("a, button, summary")) return
      // content area is only reachable when open (overflow:hidden hides it when closed)
      details.open = false
    })
  })
}
